import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Payments from '../components/Payments';
import Locations from '../components/Locations';


const LocationsPage = () => {
    return (
        <>
            <Header />
            <Locations/>
            <Footer />
        </>
    )
}

export default LocationsPage;